import { ArrowRight } from "lucide-react";
import { useLeadModal } from "@/context/LeadModalContext";
import { useQuiz } from "@/context/QuizContext";
import { APP_LINKS } from "@/data/content";
import { trackEvent, withUtm } from "@/lib/track";

const VARIANTS = {
  primary: "bg-brand text-white shadow-glow hover:bg-brand-dark",
  light: "bg-white text-brand shadow-soft hover:shadow-lift",
  outline: "border-2 border-brand/25 text-brand hover:border-brand hover:bg-brand/5",
  dark: "bg-ink text-white hover:bg-slate-800",
  ghostLight: "border-2 border-white/40 text-white hover:bg-white/10",
};

const SIZES = {
  md: "px-6 py-3 text-sm",
  lg: "px-8 py-4 text-base",
  xl: "px-10 py-5 text-lg",
};

export const CtaButton = ({
  children,
  source = "geral",
  plan = null,
  variant = "primary",
  size = "lg",
  action = "store",
  className = "",
  testId = "cta-button",
  withArrow = true,
}) => {
  const { open } = useLeadModal();
  const quiz = useQuiz();
  const handleClick = () => {
    trackEvent("click_cta_primary", { source, plan });
    trackEvent("cta_click", { source, plan });
    if (action === "quiz") {
      trackEvent("hero_cta_click", { source });
      quiz.open();
      return;
    }
    const ua = navigator.userAgent;
    if (/iPhone|iPad|iPod|Android/i.test(ua)) {
      const ios = /iPad|iPhone|iPod/.test(ua);
      trackEvent("app_download_click", { location: source });
      trackEvent(ios ? "app_store_click" : "google_play_click", { location: source });
      trackEvent(ios ? "app_store_clicked" : "google_play_clicked", { location: source });
      window.location.href = withUtm(ios ? APP_LINKS.appStore : APP_LINKS.playStore);
      return;
    }
    open(source, plan);
  };
  return (
    <button
      data-testid={testId}
      onClick={handleClick}
      className={`group inline-flex items-center justify-center gap-2.5 rounded-full font-display font-bold tracking-tight transition-all duration-300 hover:scale-[1.04] active:scale-95 ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
    >
      {children}
      {withArrow && (
        <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1.5" />
      )}
    </button>
  );
};
